import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/content/task_list',
    ADD: '/content/task_add',
    UPDATE: '/content/task_update',
	DEL: '/content/task_del',
	SET_ENABLE: '/content/task_set_enable',
    IS_EXIST_TASK_NAME: '/content/task_is_exist_name',
}

export async function taskList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function taskAdd(form) {
    return requestPost(api.ADD, form);
}

export async function taskUpdate(form) {
    return requestPost(api.UPDATE, form);
}

export async function taskDel(id) {
	let params = {id: id};
    return requestPost(api.DEL, params);
}

export async function taskSetEnable(id, enable) {
	let params = { id, enable};
    return requestPost(api.SET_ENABLE, params);
}

export async function taskNameIsExist(name) {
    let params = {val: name};
    return requestGet(api.IS_EXIST_TASK_NAME, params);
}

